<template>
    <auth-layout :image="2" :progress="75">
        <common-content-wrapper width="small">
            <common-page-header
                :heading="$t('pages.auth.signup.steps.practice.heading', { type: `${$t('common.practice_type.company')}` })"
                :content="pageContent"
            ></common-page-header>
        </common-content-wrapper>
        <ancillary-table :ancillaryServices="ancillaryServices" @ancillary-selection-save="saveChanges"></ancillary-table>
    </auth-layout>
</template>

<script>
    import SignupPageMixin from 'mixins/SignupPageMixin'
    import AuthLayout from 'components/layouts/AuthLayout'
    import AncillaryTable from 'components/page-elements/ancillary-table/AncillaryTable'
    import FacilityServicesAPI from 'api/FacilityServicesAPI'

    export default {
        mixins: [SignupPageMixin],

        components: {
            AuthLayout,
            AncillaryTable,
        },

        data() {
            return {
                ancillaryServices: [],
            }
        },

        computed: {
            pageContent() {
                return this.$t('pages.auth.signup.steps.practice.description1')
            },
        },

        methods: {
            loadAncillary() {
                FacilityServicesAPI.getFacilityServiceGroups().then((response) => {
                    this.ancillaryServices = response
                })
            },

            saveChanges(value) {
                FacilityServicesAPI.createFacilityServiceTypes(this.$auth.getPractice().id, {
                    facilityServiceIds: value.map((item) => item.id),
                }).then(() => {
                    this.goToNextStep()
                })
            },
        },

        mounted() {
            this.loadAncillary()
        },
    }
</script>
